module.exports = {
  install(Vue) {
    Vue.prototype.numberGame = {
      init(count, units) {
        const result = [];
        const length = Math.ceil(count / units);
        let left = count;

        for (let i = 0; i < length; i += 1) {
          const obj = [];
          let getCount = 0;
          for (let j = 0; j < (left >= units ? units : left); j += 1) {
            obj[j] = Math.floor(Math.random() * 10);
            getCount += 1;
          }
          left -= getCount;
          result[i] = obj;
        }

        return result;
      },
      check(answer, input) {

      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/plugins/game_number.js